module.exports = __webpack_public_path__ + "img/arrow-right.73673342.svg";